import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EstadosRol } from './entity\'estados-rol.models';

export const entityEstadosRolAdapter: EntityAdapter<EstadosRol> =
  createEntityAdapter<EstadosRol>({
    selectId: (model) => model.id,
    sortComparer: (a: EstadosRol, b: EstadosRol): number =>
      a.nombre.toString().localeCompare(b.nombre.toString())
  });

export interface EntityEstadosRolState extends EntityState<EstadosRol> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityEstadosRolState =
  entityEstadosRolAdapter.getInitialState({
    isLoading: false,
    error: null
  });
